export const environment = {
  name: 'dev',
  production: true,
  encryptKey: '1203199320052021',
  encryptIV: '1203199320052021',
  apibaseurl: 'http://vijaykumar89-002-site4.dtempurl.com/',
};
